// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2po53","textarea":"styles_textarea__13rFW"};